import { Injectable } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { Role, Permission, ROLE_PERMISSIONS } from '../lib/rbac.config';

@Injectable({ providedIn: 'root' })
export class RbacService {
  private _role: Role = Role.NONE;

  constructor(private authService: AuthService) {}

  /** Call from APP_INITIALIZER (page load/refresh) and right after a successful login. */
  init(): void {
    this._role = this.authService.getRole();
  }

  /** Call on logout, alongside authService.clearSession(). */
  reset(): void {
    this._role = Role.NONE;
  }

  get role(): Role {
    return this._role;
  }

  hasPermission(permission: Permission): boolean {
    const access = ROLE_PERMISSIONS[this._role];
    if (access.denied?.some(prefix => permission.startsWith(prefix))) return false;
    if (access.granted.includes('*')) return true;
    if (access.granted.includes(permission)) return true;
    const modulePrefix = permission.slice(0, permission.lastIndexOf('.'));
    return access.granted.includes(`${modulePrefix}.all` as Permission);
  }

  hasAnyPermission(permissions: Permission[]): boolean {
    return permissions.some(p => this.hasPermission(p));
  }
}
